const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Lightning Fast Delivery',
    description: 'Get your meals delivered under 1 hour, every time. We optimise every route for speed.',
    bg: 'bg-orange-50',
    iconColor: 'text-orange-500',
  },
  {
    icon: 'ri-map-pin-range-line',
    title: 'Live GPS Tracking',
    description: 'Watch your rider in real-time on the map from the moment they pick up your order.',
    bg: 'bg-teal-50',
    iconColor: 'text-[#009E81]',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Secure Payments',
    description: 'Pay with card, mobile money, or SPC tokens. All transactions are fully encrypted.',
    bg: 'bg-green-50',
    iconColor: 'text-green-600',
  },
  {
    icon: 'ri-restaurant-2-line',
    title: 'Top Verified Restaurants',
    description: 'Every restaurant on our platform is vetted for food quality, hygiene, and reliability.',
    bg: 'bg-rose-50',
    iconColor: 'text-rose-500',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '24/7 Support',
    description: 'Our support team is always on standby via chat, call, or email — any time of day.',
    bg: 'bg-indigo-50',
    iconColor: 'text-indigo-500',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-white py-16 md:py-24 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-[#E6F7F4] text-[#009E81] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Why Sweetplate
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Built different, for the better
          </h2>
          <p className="mt-4 text-gray-500 text-base md:text-lg max-w-xl mx-auto">
            We didn&apos;t just build a food delivery app — we built a complete culinary ecosystem.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-6 md:p-7 rounded-2xl border border-gray-100 hover:border-[#009E81]/30 transition-all duration-300 cursor-default"
            >
              <div
                className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${f.bg} mb-4 md:mb-5 transition-transform duration-300 group-hover:-translate-y-1`}
              >
                <i className={`${f.icon} text-lg md:text-xl ${f.iconColor}`} />
              </div>
              <h3 className="text-sm md:text-base font-bold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-gray-500 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
